import {createAsyncThunk} from '@reduxjs/toolkit';

export const initAmountForPremiumSavingsAd = createAsyncThunk('initAmountForPremiumSavingsAd', async () => {
  return window.PMW.readLocal('user/getAmountForPremiumSavingsAd');
});
